const rivoCustomerId = window.Rivo.common && window.Rivo.common.customer ? window.Rivo.common.customer.id : null;

function toggleWairElements(isLoad) {
  const wairElements = document.querySelectorAll('.predict-placement');
  if (wairElements.length) {
    setTimeout(() => {
      for (let i = 0; i < wairElements.length; i += 1) {
        const elem = wairElements[i];
        const elemParent = elem.parentNode.parentNode;
        const activeText = elemParent.querySelectorAll('.wair-active');
        const inactiveText = elemParent.querySelectorAll('.wair-inactive');
        if (activeText && inactiveText && ((isLoad && !window.hasPrediction) || !isLoad)){
          if (!isLoad) {
            for (let j = 0; j < activeText.length; j += 1) {
              activeText[j].style.display = 'inline-block';
            }
            for (let j = 0; j < inactiveText.length; j += 1) {
              inactiveText[j].style.display = 'none';
            }
          } else {
            for (let j = 0; j < activeText.length; j += 1) {
              activeText[j].style.display = 'none';
            }
            for (let j = 0; j < inactiveText.length; j += 1) {
              inactiveText[j].style.display = 'inline-block';
            }
          }
        }
      }
    }, isLoad ? 4000 : 200);
  }
}

window.addEventListener('onPredictModalClose', () => {  
  toggleWairElements(false);
});
window.addEventListener("onPredictPrediction", () => {
  if (rivoCustomerId) {
    const customActionUrl = `${window.Rivo.global_config.proxy_paths.loy}/loy/customers/${rivoCustomerId}/record_custom_action`;
    const response = fetch(customActionUrl, {
      method: "post",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        custom_action_name: "Complete our fit quiz",
      }),
    });
  }
  window.hasPrediction = true;
  toggleWairElements(false);
});

window.addEventListener("onPredictLoad", function () {
  toggleWairElements(true);
});
